import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a4ba968ca334e0014f8e23e_1783774308734_90833b07/instaextract/src/app/sign-up-login-screen/components/AuthScreen.tsx");
